
<button 
  pButton 
  type="button" 
  [ngClass]="appClass" 
  (click)="_click()" 
  [disabled]="loading || disabled"
  class="w-full"
>
  <!-- 如果有 loading，顯示 Spinner；否則顯示 Label -->
  <ng-container *ngIf="!loading; else load">
    {{ appLabel }}
  </ng-container>
  
  <ng-template #load>
    <i class="pi pi-spin pi-spinner"></i> <!-- 建議改用 PrimeIcons 比較一致 -->
  </ng-template>
</button>